import { mapBundleConstituentsToPie } from 'components/Charts/Victory/PieChart/mapper';
import { PieChartWrapper } from 'components/Charts/Wrappers';
import { IBundle, IBundleConsituent } from 'entities/cdn';
import { useCurrencies } from 'hooks/useCurrencies';
import React, { useState, useEffect } from 'react'
import { fetchBundle } from 'services/cdn';
import colors from 'styles/colors'

export const BundleContainer = ({ productCode }: { productCode: string | null }) => {
	// #region HOOKS
	const currencies = useCurrencies();
	// TODO: get from URL params
	const chartProvider = 'victory'
	//#endregion

	//#region STATE
	const [loading, setLoading] = useState<boolean>(true);
	const [bundle, setBundle] = useState<IBundle | undefined>()
	const [activeAsset, setActiveAsset] = useState<string>();
	// derived state:
	// const productCode = searchParams.get('productCode')
	//#endregion

	//#region LIFECYCLE
	useEffect(() => {
		fetchBundle({
			code: productCode,
		}).then((response: any) => {
			setBundle(response?.[0])
			// set first asset to active asset
			setActiveAsset(response?.[0].Assets?.[0].Code)
		}).catch((error: any) => {
			console.log('error', error)
		}).finally(() => setLoading(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	//#endregion

	const iconCdnUrl = 'https://revixdevpublic.blob.core.windows.net/assets/products/trade/';

	const SVGGainLoss = ({
		x, y, gainLossValue, gainLossPercentage,
	}: {
		x: number, y: number, gainLossValue: number, gainLossPercentage: number,
	}) => {
		return (
			<text
				x={x}
				y={y}
				fill={gainLossPercentage >= 0 ? colors.palette.GAIN : colors.palette.LOSS}
				stroke={gainLossPercentage >= 0 ? colors.palette.GAIN : colors.palette.LOSS}
				textAnchor="middle">
				{gainLossPercentage >= 0 ? '↑' : '↓'}
				{`${gainLossPercentage?.toFixed?.(2)}%`}
			</text>
		)
	}

	const getCurrencyData = (code: string) => {
		let backgroundColor = "#eeebff";
		let textColor = "rgb(109, 114, 139)";
		const isActive = code?.toUpperCase() === activeAsset?.toUpperCase();
		if (isActive) backgroundColor = currencies?.[code]?.colors?.primary;
		if (isActive) textColor = "black";
		const name = currencies?.[code]?.name;
		return { name, backgroundColor, textColor };
	};

	const SVGCenter = ({
		name,
		code,
		price,
		gainLossValue,
		gainLossPercentage,
	}: any) => {
		const svg = {
			width: 400, //window.innerWidth,
			height: 400, //window.innerHeight,
			// xOffset: window.innerWidth * 0.1,
			// yOffset: window.innerHeight * 0.1
			xOffset: 400 * 0.1,
			yOffset: 400 * 0.1
		}

		return <div style={{ width: '100%', alignItems: 'center', margin: 'auto' }}>
			<svg
				viewBox={`0 0 ${svg.width} ${svg.height}`}
				width={svg.width}
				height={svg.height}
				style={{ width: '100%', height: '100%' }}
				xmlns="http://www.w3.org/2000/svg">
				<text x={svg.width / 2} y={svg.yOffset * 1 + 20} fill="#000" textAnchor="middle" fontSize={'24'}>{name || code}</text>
				<text x={svg.width / 2} y={svg.yOffset * 2 + 20} fill="#666" textAnchor="middle">Current weight</text>
				<text x={svg.width / 2} y={svg.yOffset * 3 + 20} fill="#666" textAnchor="middle">Rebalance weight</text>
				<text x={svg.width / 2} y={svg.yOffset * 4 + 20} fill="#666" textAnchor="middle">Returns since rebalance</text>
				<SVGGainLoss
					x={svg.width / 2}
					y={svg.yOffset * 5 + 20}
					gainLossValue={gainLossValue}
					gainLossPercentage={gainLossPercentage}
				/>
			</svg>
		</div>
	}
	return (
		<div style={{ marginTop: '0' }}>
			{loading ? (
				<div className="loader" />
			) : (
				(
					<>
						<PieChartWrapper
							data={mapBundleConstituentsToPie(bundle, currencies)}
							provider={chartProvider || 'victory'}
							centerElement={
								<SVGCenter
									code={activeAsset}
									name={currencies[activeAsset as string].name}
									gainLossPercentage={1.23}
									gainLossValue={4.56}
								/>
							}
						/>
						<div style={{ display: 'flex', padding: "50px", flexWrap: "wrap", justifyContent: 'center' }}>
							{bundle?.Assets.map((asset: IBundleConsituent) => (
								<button style={{
									display: "flex", alignItems: "center", border: "none", cursor: "pointer", borderRadius: "0.5rem", boxShadow: "rgb(238, 235, 255) 0px 0px 10px 1px", background: "white", margin: "10px", width: "160px", padding: "7px"
								}}
									onClick={() => setActiveAsset(asset.Code)}
								>
									<div style={{
										backgroundColor: getCurrencyData(asset.Code).backgroundColor,
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										borderRadius: "50%",
										width: "2.3rem",
										height: "2.3rem",
										marginRight: "0.25rem"
									}}>
										<img
											src={`${iconCdnUrl}${asset.Code.toLowerCase()}.svg`}
											alt={`${asset.Code}-icon`}
										/>
									</div>
									<div style={{ color: getCurrencyData(asset.Code).textColor }}>{getCurrencyData(asset.Code).name}</div>
								</button>
							))}
						</div>
					</>
				)
			)}
		</div>
	)
}